module.exports = __webpack_public_path__ + "img/7d986df93f544aa8806d9633caefd562.png";